import { render, staticRenderFns } from "./UserTransactions.vue?vue&type=template&id=a193d260&"
import script from "./UserTransactions.vue?vue&type=script&lang=js&"
export * from "./UserTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserTransactions.vue"
export default component.exports